import VueUploadComponent from 'vue-upload-component'
import RadialProgressBar from 'vue-radial-progress'
import {getRequestHeaders} from "@/shared/utils";
import {config} from '../../../config/config';

export default {
    name: 'FileBtn',
    components: {
        FileUpload: VueUploadComponent,
        RadialProgressBar
    },
    props: ['value', 'preview', 'optional'],
    data() {
        return {
            percentage: 0,
            error: '',
            inProgress: false,
            file: {},
            imagePreview: this.preview
        }
    },
    computed: {},
    mounted() {
        this.headers = getRequestHeaders();
    },
    methods: {
        onSelectFile(e) {
            this.error = '';
            var formData = new FormData();
            // Attach file
            this.file = e.target.files[0]
            let fileSize = this.file.size/1024/1024
            if(fileSize>1){
                this.error = 'Error: Maximum file size is 1MB for images.';
                return;
            }
            var reader = new FileReader();
            reader.onload =  (e) => {
                this.imagePreview = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);

            formData.append('file', e.target.files[0]);
            var xhr = new XMLHttpRequest();
            this.inProgress = false;
            var headers = getRequestHeaders();
            xhr.withCredentials = true;
            // eslint-disable-next-line no-undef
            xhr.open("POST", config('API_PATH') + "/api/lookups/upload_image/i");
            xhr.upload.addEventListener('progress', (oEvent) => {
                this.inProgress = true;
                this.$store.commit('setUploadStatus', this.inProgress)
                if (oEvent.lengthComputable) {
                    var percentComplete = oEvent.loaded / oEvent.total * 100;
                    this.percentage = parseInt(percentComplete);
                } else {
                    // Unable to compute progress information since the total size is unknown
                }
            }, false)

            xhr.setRequestHeader("X-CSRFToken", headers['X-CSRFToken'])
            xhr.send(formData);
            xhr.addEventListener('load', (e) => {
                let response = JSON.parse(e.currentTarget.responseText);
                if (e.currentTarget.status === 200) {
                    this.$emit('input', response['id']);
                } else {
                    this.$emit('input', null);
                    this.error = response.error.image[0];
                }
                setTimeout(() => {
                    this.inProgress = false;
                    this.$store.commit('setUploadStatus', this.inProgress)
                }, 500);
            });
        }
    }
}
// progress on transfers from the server to the client (downloads)
